import Image from 'app/Components/Shared/Image/image';
import React, { useLayoutEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { goToPage, setSelectedSubscriber, setSubscribersDetails } from '../../Page/SelfCarePage/SelfCareSlice';
import { validateInput, TextInputEnum } from '../../../utilities/validation/InputValidation';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import TextInput from '../../Shared/TextInput/TextInput';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import { needsToSignCollaboration, ChangeSubscriberDetails } from './UpdateSubscriberNameAsyncThunk';
import { isMobile } from 'react-device-detect';
import Config from '../../../Config';
import { setItem } from '../../../utilities/localStorageUtils';
import EpiContext from '@episerver/spa-core/Spa';
import { refreshToken } from '../../../utilities/authentication/authenticationSlice';
const UpdateSubscriberName = (props) => {
  const [firstName, setFirstName] = useState(props.subscriber?.productFirstName ?? "");
  const [lastName, setLastName] = useState(props.subscriber?.productLastName ?? "");
  const [errors, setErrors] = useState({ firstName: '', lastName: '' });
  const [thirdPartyIsRequired, setThirdPartyIsRequired] = useState(false);
  const [thirdPartyIsChecked, setThirdPartyIsChecked] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [updateSucceeded, setUpdateSucceeded] = useState(false);

  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;

  useLayoutEffect(() => {
    if (!props.subscriber) {
      EpiContext.navigateTo(Config.lobbyUrl);
    }
    checkCollab();
  }, []);

  const checkCollab = async () => {
    var res = await props.needsToSignCollaboration({ subscriber: props.subscriber.productSubscriberNo });
    setThirdPartyIsRequired(res.payload);
  };

  const handleChangeName = async () => {
    var errorFname = validateInput(firstName, TextInputEnum.HebrewFirstName);
    var errorLname = validateInput(lastName, TextInputEnum.HebrewLastName);

    if (errorFname === '' && errorLname === '') {
      props.showAppLoader();
      var res = await props.ChangeSubscriberDetails({
        newFirstName: firstName,
        newLastName: lastName,
        selectedNumber: props.subscriber.productSubscriberNo,
        isThirdPartySign: thirdPartyIsChecked,
        updatePrivateSubscriber: true
      });
      props.hideAppLoader();
      if (res.payload.isSuccess) {
        setUpdateSucceeded(true);
        await props.setSubscribersDetails({ firstName, lastName, cli: props.subscriber.productSubscriberNo });
        props.refreshToken();
      }
      setIsSubmit(true);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className='wrapper_page'>
      <div className='editPersonalInfoPage mainContent'>
        {!isSubmit ? (
          <div className='updateContainer'>
            <div className='backBtn' onClick={() => window.history.back()} >
              {isMobile ? (
                <Image src={require('./icon/arrowBackMobile.svg')} />
              ) : (
                <>
                  <Image src={require('./icon/arrowBackDesktop.svg')} />
                  חזרה לאיזור האישי
                </>
              )}
            </div>
            <p className='title'>איך לפנות אליך?</p>
            <p className='subTitle'>
              כדי שנוכל להכיר טוב יותר ולשלוח לך עדכונים שיתאימו לך  נשמח לדעת כמה פרטים
            </p>
            <div>
              <div className='inputContainer'>
                <TextInput
                  value={firstName}
                  error={errors.firstName}
                  id='firstName'
                  placeholder={'שם פרטי'}
                  onChange={(e) => {
                    setErrors({ ...errors, firstName: validateInput(e.target.value, TextInputEnum.HebrewFirstName) });
                    setFirstName(e.target.value);
                  }}
                  ref={firstNameRef}
                  required='required'
                />

                <TextInput
                  value={lastName}
                  error={errors.lastName}
                  id='lastName'
                  placeholder={'שם משפחה'}
                  onChange={(e) => {
                    setErrors({ ...errors, lastName: validateInput(e.target.value, TextInputEnum.HebrewLastName) });
                    setLastName(e.target.value);
                  }}
                  ref={lastNameRef}
                  required='required'
                /></div>
              {thirdPartyIsRequired && (
                <CheckBox
                  onCheck={(e) => setThirdPartyIsChecked(true)}
                  onUncheck={(e) => setThirdPartyIsChecked(false)}
                  label={<ThirdParty />}
                  id='isReceivingAd'
                  checked={thirdPartyIsChecked}
                />
              )}
            </div>
            <BtnSubmit text={'עדכון פרטים'} onclick={() => handleChangeName()} />{' '}
          </div>
        ) : (
          <div className='finalPage'>
            {updateSucceeded ? (
              <>
                <Image src={require('./icon/SuccessIcon.svg')} />
                <p className='text'> מעולה! הפרטים שלך מעודכנים</p>
                <BtnSubmit text={'חזרה למסך הראשי'} onclick={() => window.history.back()} />{' '}
              </>
            ) : (
              <>
                <Image src={require('./icon/editSubscriberIcon.svg')} />
                <p className='subTitle'> נראה שמשהו השתבש</p>
                <p className='text'> לצערנו לא הצלחנו לעדכן את הפרטים שלך, אפשר לנסות שוב מאוחר יותר או לדבר עם נציג</p>
                <BtnSubmit
                  className='btn-submit-white'
                  isDisplayWhatsAppIcon={true}
                  onclick={() => {
                    window.location.href = whatsAppLink;
                  }}
                  text='יצירת קשר ב-WhatsApp'
                />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriber: state.selfcarePage.selectedSubscriber,
    loginData: state.authentication.loginData,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedSubscriber,
  ChangeSubscriberDetails,
  needsToSignCollaboration,
  setSubscribersDetails,
  showAppLoader,
  hideAppLoader,
  refreshToken
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSubscriberName);
